import * as React from "react";
import RecordGroupsPanel from "../RecordGroupsPanel";
import "./PeopleGroupsTab.scss";

const PeopleGroupsTab = ({ data, viewMode, ownerAgentId }) => {
  return (
    <div className="People-groups-tab">
      {ownerAgentId ? (
        <RecordGroupsPanel
          groupType="people"
          memberId={data && data.contact_id}
          ownerAgentId={ownerAgentId}
          viewMode={viewMode}
          title="People Groups"
        />
      ) : null}
    </div>
  );
};

export default PeopleGroupsTab;
